namespace Reviews {

    class ReviewPreview {

        public reviewDetails: ReviewDetails;
        public userInput :ReviewData;

        private bookingId :number;
        private token :string;
        private userId :string;

        constructor(protected $location: ng.ILocationService,
                    protected $routeParams: ng.route.IRouteParamsService,
                    protected analytics: any,
                    protected reviewPreviewStoreService: ReviewPreviewStoreService,
                    protected reviewsService: ReviewsService) {

            this.bookingId = $routeParams.bookingId;
            this.token = $routeParams.token;
            this.userId = $routeParams.userId;

            this.reviewDetails = reviewPreviewStoreService.getReviewDetails();
            this.userInput = reviewPreviewStoreService.getUserInput();

            if (!this.reviewDetails) {
                this.gotoReviewPage();
            }
        }

        public makeChange() {
            this.gotoReviewPage();
        }

        public submitReview() {
            this.reviewsService.submitReview(this.userInput, this.bookingId, this.token).then(() => {
                //not keen on this event name, but to keep reporting comparable we have used it
                this.analytics.track('mixpanel',
                    'MYB - Review submitted',
                    this.userInput.getRatingData());
                this.$location.path(`/review-hotel/submitted/${this.reviewDetails.hotelDetails.id}`);
            });
        }

        private gotoReviewPage() {
            this.$location.path(`/review-hotel/${this.bookingId}/${this.userId}/${this.token}`);
        }

    }

    angular
        .module('reviews')
        .controller('ReviewPreview', ReviewPreview);

}
